import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
type Notification = (typeof purchaseNotifications)[number];
const TIMES = ['1 minute ago', '2 minutes ago', '4 minutes ago', '7 minutes ago', '12 minutes ago'];

/** Rotating social-proof popup: "X just purchased the digital book". */
export function PurchasePopup() {
  const [current, setCurrent] = useState<{
    item: Notification;
    time: string;
  } | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * purchaseNotifications.length);
    let hideTimer: number;
    const show = () => {
      index = (index + 1) % purchaseNotifications.length;
      setCurrent({
        item: purchaseNotifications[index],
        time: TIMES[Math.floor(Math.random() * TIMES.length)]
      });
      hideTimer = window.setTimeout(() => setCurrent(null), 5200);
    };
    const firstTimer = window.setTimeout(show, 6000);
    const interval = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  return <AnimatePresence data-id="element-38" data-mp="1ax7lmyk40qwv">
      {current && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 24,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 26
    }} className="fixed bottom-[92px] left-3 right-3 z-40 sm:right-auto sm:max-w-[330px]" role="status" aria-live="polite" data-id="element-39" data-mp="n6lj1msvjyu9">
          <div className="relative flex items-center gap-3 rounded-2xl border border-gold/25 bg-white p-3 pr-8 shadow-[0_18px_40px_-16px_rgba(14,21,38,0.45)]" data-id="element-40" data-mp="28joik2oxl2i3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-50" data-id="element-41" data-mp="23npmdsxd2g74">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600" aria-hidden="true" data-id="element-42" data-mp="2fno3thbxho3b" />
            </div>
            <div className="min-w-0" data-id="element-43" data-mp="2kn0opwj8ol39">
              <p className="truncate text-[13px] font-bold text-ink" data-id="element-44" data-mp="2ko29wttyynyp">{current.item.name}</p>
              <p className="text-[11px] leading-snug text-ink-soft" data-id="element-45" data-mp="2pksm362nkzeu">
                just purchased the digital book · {current.item.place}
              </p>
              <p className="text-[10px] font-medium uppercase tracking-wide text-gold-dark" data-id="element-46" data-mp="1wx6dtkihd6ln">
                {current.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-ink-soft/60 transition-colors hover:bg-sand hover:text-ink" data-id="element-47" data-mp="21uoj90xah3ow">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="1e5dr27u08hmd" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}